import React from 'react'
import { NavLink } from "react-router-dom";
import { auth } from "firebase";

const nav = ({click, active}) =>
<nav>
    <NavLink onClick={() => click('/list')} className={active === 'l' ? "active" : ""} to="/list">TrackList</NavLink>
    <NavLink onClick={() => click('/search')} className={active === 's' ? "active" : ""} to="/search">Search</NavLink>
    <a onClick={() => auth().signOut()}>logout</a>
</nav>

export default nav;


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/navbar.js